// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__2XpHS","icon":"SearchInput_icon__31H3_","input":"SearchInput_input__34z7q"};